import {
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../../hooks";
import { columnClubDetail } from "../../../helpers/columns/columnDivestment";
import { fetchData } from "../../../helpers/getData/fetchData";
import { TableLayout } from "../../../layout/TableLayout";

export const SearchByUser = () => {
  const { t } = useTranslation("global");
  const [formValues, handleInputChange] = useForm({ partnerName: "" });

  const { partnerName } = formValues;
  const [divestmentData, setDivestmentData] = useState(null);
  const [userList, setUserList] = useState(null);

  useEffect(() => {
    fetchData(setUserList, "/user/getListNameAndId?type=Admin", t);
  }, [t]);

  const handleClic = () => {
    const id = userList.find((user) => user.name === partnerName).id;
    fetchData(setDivestmentData, `/divestment?user=${id}`, t);
  };

  return (
    <Stack direction="column" width="100%" gap={0}>
      {userList ? (
        <>
          <Typography variant="overline" color="secondary">
            {t("search.byUser")}
          </Typography>
          <Stack
            direction="row"
            flexWrap="wrap"
            gap={2}
            width="100%"
            justifyContent="space-between"
          >
            <Autocomplete
              disablePortal
              options={userList.map((user) => user.name)}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="partnerName" />
              )}
              value={partnerName}
              onSelect={handleInputChange}
              required
              sx={{ width: "80%" }}
            />
            <Button
              sx={{ width: "140px" }}
              onClick={handleClic}
              variant="contained"
            >
              {t("search.search")}
            </Button>
          </Stack>
        </>
      ) : (
        <CircularProgress />
      )}
      {divestmentData && (
        <Stack mt={2}>
          <TableLayout rows={divestmentData} columns={columnClubDetail(t)} title="noTitle" />
        </Stack>
      )}
    </Stack>
  );
};
